import mdPage from '../../src/views/knowledge/mdPage'

export default {
  mdPage:mdPage,
}